<div [hidden]="!contractRef">
  <div
    *ngIf="isLoading"
    class="row center">
    <div class="col">
      <app-loading-icon
        class="u-color--light"
        size="2x"></app-loading-icon>
    </div>
  </div>
  <div
    *ngIf="!dataSource.data?.length"
    class="row center">
    <div class="col">
      <h2>{{ "contract.notoolsfound" | translate }}</h2>
    </div>
  </div>
  <div
    [hidden]="!dataSource.data?.length"
    class="u-mb-2">
    <div class="col">
      <div class="o-grid u-pb--medium between u-align-center">
        <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
          <form class="c-search-form--full">
            <div class="c-input-group">
              <input
                type="text"
                name="search"
                id="input-search"
                [(ngModel)]="dataSource.filter"
                class="c-input c-input--beta"
                placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
                required />
              <input
                *ngIf="dataSource.filter"
                id="contract-tools-search-clear"
                (click)="dataSource.filter = ''"
                class="c-button c-button--search c-close-search c-button--search--sm"
                value="Clear" />
              <input
                *ngIf="!dataSource.filter"
                id="contract-tools-search"
                type="submit"
                class="c-button c-button--search c-button--search--sm"
                value="Search" />
            </div>
          </form>
        </div>

        <div class="o-grid__item">
          <tool-export-button
            [excelExportType]="ExcelExportType.ContractTools"
            [toolFilter]="filter"></tool-export-button>
        </div>
      </div>
      <div
        id="contract-tools"
        class="col bg-white u-shadow u-scroll--horizontal">
        <div
          id="tool-table"
          class="tools-table col">
          <table
            mat-table
            matSort
            [dataSource]="dataSource"
            class="c-table">
            <ng-container
              *ngFor="let col of columns"
              [matColumnDef]="col.key">
              <th
                mat-header-cell
                mat-sort-header
                *matHeaderCellDef
                class="c-table__column-title">
                {{ col.title | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let row"
                class="c-clickable"
                [routerLink]="[
                  routeNameConstants.TOOLS_DETAILS_BASE,
                  row.companyId,
                  row.serialNumber,
                ]">
                {{ row[col.key] }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="columnKeys"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: columnKeys"
              class="c-table__row"></tr>
          </table>
        </div>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
